// extracted by mini-css-extract-plugin
module.exports = {"Modal":"styles_Modal__1bvsT","button":"styles_button__3og0o"};